import { IProps } from '@/Interfaces/Icons/Props.interface';
import { Percent as Icon } from '@mui/icons-material';

const PercentIcon = ({ height, width, ...props }: IProps) => (
  <Icon {...props} sx={{ width: width ?? 16, height: height ?? 16 }} />
);

export default PercentIcon;
